export const EMAIL_REPORT_LOADING = 'EMAIL_REPORT_LOADING'
export const EMAIL_REPORT_LOADED = 'EMAIL_REPORT_LOADED'
export const EMAIL_REPORT_COMPANIES_LOADED = 'EMAIL_REPORT_COMPANIES_LOADED'
export const EMAIL_REPORT_NEW_COMPANY_SELECTED = 'EMAIL_REPORT_NEW_COMPANY_SELECTED'
export const EMAIL_ALL_COMPANIES_LOADING = 'EMAIL_ALL_COMPANIES_LOADING'
export const EMAIL_ALL_COMPANIES_LOADED = 'EMAIL_ALL_COMPANIES_LOADED'
export const EMAIL_REPORT_EDIT_LOADED = 'EMAIL_REPORT_EDIT_LOADED'